
<div class="d-flex flex-column flex-shrink-0 p-3 bg-light" style="width: 250px; height: 88vh;" id="sidebar">
  <ul class="nav nav-pills flex-column mb-auto">
    <li class="nav-item" *ngIf="hasPermission(Permissions.Summary)">
      <a routerLink="/dashboard/summary" class="nav-link text-dark">
          <i class="bi bi-speedometer2"></i> {{ translationService.getTranslation('Dashboard') }}
      </a>
    </li>
    <li class="nav-item" *ngIf="hasPermission(Permissions.ExamFolder)">
      <a routerLink="/dashboard/exam-folders" class="nav-link text-dark">
          <i class="bi bi-folder"></i> {{ translationService.getTranslation('Exam Folders') }}
      </a>
    </li>
    <li class="nav-item" *ngIf="hasPermission(Permissions.QuestionsAndAnswers)">
      <a routerLink="/dashboard/questions-and-answers" class="nav-link text-dark">
          <i class="bi bi-question-circle"></i> {{ translationService.getTranslation('Questions and Answers') }}
      </a>
    </li>
    <li class="nav-item" *ngIf="hasPermission(Permissions.FormSetup)">
      <a routerLink="/dashboard/forms-setup" class="nav-link text-dark">
          <i class="bi bi-file-earmark-text"></i> {{ translationService.getTranslation('Forms Setup') }}
      </a>
    </li>
    <li class="nav-item" *ngIf="hasPermission(Permissions.ExamSchedule)">
      <a routerLink="/dashboard/exam-schedule" class="nav-link text-dark">
          <i class="bi bi-calendar"></i> {{ translationService.getTranslation('Exam Preparation') }}
      </a>
    </li>
    <li class="nav-item" *ngIf="hasPermission(Permissions.Exam)">
      <a routerLink="/dashboard/exam" class="nav-link text-dark">
          <i class="bi bi-file-earmark"></i> {{ translationService.getTranslation('Exam') }}
      </a>
    </li>
    <li class="nav-item" *ngIf="hasPermission(Permissions.Report)">
      <a routerLink="/dashboard/reports" class="nav-link text-dark">
          <i class="bi bi-file-earmark-bar-graph"></i> {{ translationService.getTranslation('Reports') }}
      </a>
    </li>
    <li class="nav-item" *ngIf="hasPermission(Permissions.Settings)">
      <a routerLink="/dashboard/settings" class="nav-link text-dark">
        <i class="bi bi-gear-wide-connected"></i> {{ translationService.getTranslation('Settings') }}
      </a>
    </li>
  </ul>
  <hr>
    <p>{{ translationService.getTranslation('Welcome') }}<br> {{username}}</p>
    <a href="https://alarkkan.app" target="_blank">{{ translationService.getTranslation('Back to Training') }}</a>
</div>
